// import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { CHECKOUT_URL } from 'Route/Checkout/Checkout.config';
import {
    ACCOUNT_LOGIN_URL,
    ACCOUNT_URL
} from 'Route/MyAccount/MyAccount.config';
import {
    STATE_LOGGED_IN
} from 'SourceComponent/MyAccountOverlay/MyAccountOverlay.config';
import {
    mapDispatchToProps as sourceMapDispatchToProps,
    mapStateToProps as sourceMapStateToProps,
    MyAccountOverlayContainer as SourceMyAccountOverlayContainer
} from 'SourceComponent/MyAccountOverlay/MyAccountOverlay.container';
import history from 'Util/History';
import { appendWithStoreCode } from 'Util/Url';

/** @namespace PeggysagePwa/Component/MyAccountOverlay/Container/mapStateToProps */
export const mapStateToProps = (state) => ({
    ...sourceMapStateToProps(state)
    // ...
});

/** @namespace PeggysagePwa/Component/MyAccountOverlay/Container/mapDispatchToProps */
export const mapDispatchToProps = (dispatch) => ({
    ...sourceMapDispatchToProps(dispatch)
    // ...
});

/** @namespace PeggysagePwa/Component/MyAccountOverlay/Container */
export class MyAccountOverlayContainer extends SourceMyAccountOverlayContainer {
    /**
     * Override: redirect to account after registration
     * @param prevProps
     * @param prevState
     */
    componentDidUpdate(prevProps, prevState) {
        const { isSignedIn: prevIsSignedIn } = prevProps;
        const { state: oldMyAccountState } = prevState;
        const { state: newMyAccountState } = this.state;
        const { isOverlayVisible } = this.props;
        const { location: { pathname } } = history;

        const {
            isSignedIn,
            hideActiveOverlay,
            isCheckout,
            goToPreviousHeaderState,
            redirectToDashboard
        } = this.props;

        if (oldMyAccountState === newMyAccountState) {
            return;
        }

        if (isSignedIn !== prevIsSignedIn) {
            hideActiveOverlay();

            if (isCheckout) {
                goToPreviousHeaderState();
            }
        }

        if (
            newMyAccountState !== STATE_LOGGED_IN
            && pathname.includes(ACCOUNT_URL)
            && !isOverlayVisible
        ) {
            history.push({ pathname: appendWithStoreCode(ACCOUNT_LOGIN_URL) });
        }

        if (newMyAccountState === STATE_LOGGED_IN) {
            if (pathname.includes(ACCOUNT_URL)) {
                // history.push({ pathname: appendWithStoreCode('/') });
                history.push({ pathname: appendWithStoreCode(ACCOUNT_URL) });
            } else if (!pathname.includes(CHECKOUT_URL) && redirectToDashboard) {
                history.push({ pathname: appendWithStoreCode(ACCOUNT_URL) });
            }
        }
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(MyAccountOverlayContainer);
